// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import validateAntennaCode from '../validateAntennaCode'
import { isAlphaNumeric } from 'validators/common'

const validateNewAntennaCode = (v, error) => {
  validateAntennaCode(v, error, true)

  if (!error.antennaCode) {
    error.antennaCode = isAlphaNumeric(v)
  }
}

export default validateNewAntennaCode
